export default __webpack_public_path__ + "9bf74a8dd800e6a56cb5cb78c16c8f0c.png";